import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getActiveOperators = async () => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: '/monitoring-operator/shift/active-operators',
  });

  return data?.data;
};

export default getActiveOperators;
